import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CartItem, ExternalOpportunity } from '../types/opportunity.types';

interface ImportCartState {
  items: CartItem[];
  isOpen: boolean;

  // Actions
  addItem: (opportunity: ExternalOpportunity) => void;
  removeItem: (externalId: string) => void;
  clearCart: () => void;
  isInCart: (externalId: string) => boolean;
  toggleCart: () => void;
  openCart: () => void;
  closeCart: () => void;
}

export const useImportCartStore = create<ImportCartState>()(
  persist(
    (set, get) => ({
      items: [],
      isOpen: false,

      addItem: (opportunity: ExternalOpportunity) => {
        const { items } = get();
        if (items.some((item) => item.externalId === opportunity.externalId)) {
          return; // Already in cart
        }
        set({
          items: [
            ...items,
            {
              ...opportunity,
              addedAt: new Date(),
            },
          ],
        });
      },

      removeItem: (externalId: string) => {
        set({
          items: get().items.filter((item) => item.externalId !== externalId),
        });
      },

      clearCart: () => {
        set({ items: [] });
      },

      isInCart: (externalId: string) => {
        return get().items.some((item) => item.externalId === externalId);
      },

      toggleCart: () => {
        set({ isOpen: !get().isOpen });
      },

      openCart: () => {
        set({ isOpen: true });
      },

      closeCart: () => {
        set({ isOpen: false });
      },
    }),
    {
      name: 'bpa-import-cart',
      partialize: (state) => ({ items: state.items }),
    }
  )
);
